/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createExchangeRatesGetResponseFromDiscriminatorValue, type ExchangeRatesGetResponse } from '../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /exchangerate
 */
export interface ExchangerateRequestBuilder extends BaseRequestBuilder<ExchangerateRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ExchangeRatesGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ExchangeRatesGetResponse[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ExchangerateRequestBuilderUriTemplate = "{+baseurl}/exchangerate";
/**
 * Metadata for all the requests in the request builder.
 */
export const ExchangerateRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ExchangerateRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createExchangeRatesGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
